import client_core from "@/services/clients/client_core";

const EventOwnerService = {
    getEventOwners(params = {}) {
        return client_core.get('/dashboard/v1/event-owners/', { params })
    },

    getEventOwner(eventOwnerId) {
        return client_core.get(`/dashboard/v1/event-owners/${eventOwnerId}/`)
    },
}

export default EventOwnerService
